import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { Link } from 'rebass'

const Logo = props => (
  <Link
    as={GatsbyLink}
    to="/"
    variant="reverse-link"
    display="block"
    {...props}
  >
    <svg
      viewBox="0 0 126 100"
      width="126"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
      css={{ width: '100%', height: '100%' }}
    >
      <title>Go to homepage</title>
      <path d="M126 .858h-12.902v82.847H126V.859z" />
      <path
        fillRule="evenodd"
        d="M106.648.848C56.283-5.258 50.716 23.858 0 16.204v82.84c53.067 5.863 60.772-20.386 106.648-15.355V.849zM25.054 75.144c2.663 1.277 6.735 2.243 10.68 1.996 8.435-.527 15.178-4.445 14.515-15.226l-1.55-25.267-7.12.445.186 3.041c-.89-1.054-3.955-3.527-8.775-3.225-8.16.51-13.581 7.176-13.034 16.077.544 8.901 6.35 14.81 14.623 14.293 4.984-.312 7.602-3.361 8.153-4.228l.08 1.327c.276 4.478-3.427 5.986-7.534 6.243-3.943.246-7.32-1.04-8.283-1.48l-1.941 6.004zm32.211-10.028c2.623 1.356 6.666 2.445 10.616 2.318 8.448-.272 15.304-3.985 14.961-14.781l-.8-25.303-7.132.23.099 3.045c-.86-1.08-3.85-3.644-8.677-3.489-8.175.264-13.788 6.763-13.507 15.677.284 8.913 5.91 14.995 14.195 14.728 4.99-.16 7.697-3.13 8.275-3.98l.041 1.329c.142 4.484-3.602 5.88-7.718 6.012-3.948.128-7.287-1.261-8.236-1.73l-2.117 5.944zm-15.02-13.58c.315 5.142-2.44 8.644-6.82 8.918-4.273.267-7.548-2.913-7.86-8-.312-5.087 2.496-8.592 6.769-8.86 4.438-.277 7.61 3.021 7.911 7.942zm32.905-9.498c.163 5.149-2.694 8.566-7.083 8.708-4.278.137-7.457-3.14-7.617-8.235-.163-5.093 2.749-8.512 7.029-8.65 4.443-.143 7.514 3.25 7.671 8.177z"
      />
    </svg>
  </Link>
)

export default Logo
